
import GpParser from '../../gpParser';
import { CATEGORIES } from '../../configuration/constants';

import TableSimple from "./TableSimple";

export default (editor, opt = {}) => {
  GpParser.loadFromList([
    TableSimple,
  ], CATEGORIES.TABLE, editor, opt);
}
